import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 backdrop-blur-sm",
  {
    variants: {
      variant: {
        default: [
          "border-transparent bg-primary text-primary-foreground",
          "shadow-[0_2px_8px_hsl(var(--glass-shadow)),inset_0_1px_0_hsl(0_0%_100%/0.15)]",
          "hover:bg-primary/90"
        ].join(" "),
        secondary: [
          "border-[hsl(var(--glass-border-strong))] bg-[hsl(var(--glass-bg-strong))] text-secondary-foreground",
          "shadow-[inset_0_1px_0_hsl(var(--glass-highlight))]",
          "hover:bg-[hsl(var(--glass-bg))]"
        ].join(" "),
        destructive: [
          "border-transparent bg-destructive text-destructive-foreground",
          "shadow-[0_2px_8px_hsl(0_84%_60%/0.3)]",
          "hover:bg-destructive/90"
        ].join(" "),
        outline: [
          "border-[hsl(var(--glass-border-strong))] bg-[hsl(var(--glass-bg))] text-foreground",
          "shadow-[inset_0_1px_0_hsl(var(--glass-highlight))]"
        ].join(" "),
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
